import { IQualityReport } from '@travelnest/typewriter';
import { IConfiguredHttp } from './http';

export interface IPropertyQualityApi {
	getByPropertyIdAndChannel(id: string, channel: string): Promise<IQualityReport>;
}

const qualityApiFactory = (http: IConfiguredHttp, prefix = ''): IPropertyQualityApi => ({
	getByPropertyIdAndChannel(id, channel) {
		return http.get(`${prefix}/reports/${id}/${channel}/`);
	}
});

export default qualityApiFactory;
